module.exports = __webpack_public_path__ + "static/media/icn_secure_safe.99dee22a.svg";